import { VehicleModel } from 'app/models/dms/vehicle.model';
import { Component, Input } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { ContactResultModel, ContactModel } from 'app/models/dms/contact.model';
import { UserService } from 'app/services/user.service';
import { ContactClass, ContactType, SecurityRight } from 'app/utility/enums';

@Component({
    template: `
        <ion-list lines="none" class="ion-no-margin" inset="false" mode="md">
          <ion-item (click)="performAction('view')">
            <ion-label>View</ion-label>
          </ion-item>
          <ion-item (click)="performAction('activity')">
            <ion-label>Add activity</ion-label>
          </ion-item>
          <ion-item (click)="performAction('opportunities')">
            <ion-label>Opportunities</ion-label>
          </ion-item>
          @if (hasPermission('change-activation')) {
            <ion-item (click)="performAction('change-activation')">
              @if (!contactIsActive) {
                <ion-label>Activate</ion-label>
              }
              @if (contactIsActive) {
                <ion-label>Deactivate</ion-label>
              }
            </ion-item>
          }
          @if (hasPermission('delete-contact')) {
            <ion-item (click)="performAction('delete-contact')">
              <ion-label>Delete contact</ion-label>
            </ion-item>
          }
          @if (phone||email) {
            <ion-item-divider></ion-item-divider>
          }
          @if (phone) {
            <ion-item (click)="performAction('phone')">
              <ion-label>
                <ion-icon name="call"></ion-icon>&nbsp;&nbsp;{{ truncate(phone) }}
              </ion-label>
            </ion-item>
          }
          @if (phone) {
            <ion-item (click)="performAction('sms')">
              <ion-label>
                <ion-icon name="chatbox"></ion-icon>&nbsp;&nbsp;{{ truncate(phone) }}
              </ion-label>
            </ion-item>
          }
          @if (email) {
            <ion-item (click)="performAction('email')">
              <ion-label>
                <ion-icon name="mail"></ion-icon>&nbsp;&nbsp;{{ truncate(email) }}
              </ion-label>
            </ion-item>
          }
        </ion-list>
        `,
    standalone: false
})

export class ContactListItemPopover
{
    constructor(private popoverCtrl: PopoverController, private userService: UserService)
    {
    }

    @Input() contact: ContactResultModel;
    @Input() phone: string;
    @Input() email: string;
    @Input() contactIsActive: boolean = true;

    truncate(value: string): string {
        if (!value) return '';
        return value.length > 20 ? value.substring(0, 20) + '...' : value;
    }

    async onDismiss()
    {
        try
        {
            await this.popoverCtrl.dismiss();
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    async performAction(action: string)
    {
        try
        {
            await this.popoverCtrl.dismiss(action);
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    hasPermission(action: string): boolean
    {
        switch (action)
        {
            case "change-activation":
                if (this.contact.contactClass == ContactClass.Individual && this.contact.contactType != ContactType.Customer)
                {
                    return false;
                }
                return this.userService.mcMinVersion("3.2.23") && this.userService.hasUserRight(SecurityRight.ContactFunctionsDelete);
            case "delete-contact":
                return this.userService.mcMinVersion("3.2.23") && this.userService.hasUserRight(SecurityRight.ContactFunctionsDelete);
            default:
                // console.log(action+" has no permission");
                break;
        }
    }
}
